const KEY = "postAuthRedirect";

export const rememberPostAuthRedirect = (path) => sessionStorage.setItem(KEY, path);

export const consumePostAuthRedirect = (fallback = "/dashboard") => {
  const p = sessionStorage.getItem(KEY);
  sessionStorage.removeItem(KEY);
  return p || fallback;
};

export const peekPostAuthRedirect = () => sessionStorage.getItem(KEY);
